
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/support",
      function () {
        return require("private-next-pages/profile/support/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/support"])
      });
    }
  